// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"348":"chat","353":"agents","845":"profile"}[chunkId] + "." + {"348":"4c8633d4","353":"d74d5853","845":"20887fd1"}[chunkId] + ".js";
};